import { c as _c } from "react/compiler-runtime";
import { FormGroup, SelectBoxSkeleton } from '@sbt-web/ui';
import styles from './FiltersSkeletons.module.scss';
type Props = {
  size: 'small' | 'large';
};
const LOADING_SKELETONS = Array.from({
  length: 5
}, (_, index) => index);
const FiltersSkeletons = t0 => {
  const $ = _c(4);
  const {
    size
  } = t0;
  let t1;
  if ($[0] !== size) {
    t1 = LOADING_SKELETONS.map(id => <SimpleFilterSkeleton key={id} size={size} />);
    $[0] = size;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div>{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
const SimpleFilterSkeleton = t0 => {
  const $ = _c(3);
  const {
    size
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className={styles.skeleton} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== size) {
    t2 = <FormGroup>{t1}<SelectBoxSkeleton flavor={size} /></FormGroup>;
    $[1] = size;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default FiltersSkeletons;